import { AdminDailyActiveUsersFilter, AdminDailyActiveUsersResponse } from '../../graphql/API';
import { adminGetDailyActiveUsers } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDailyActiveUsersApi = async (
  filter: AdminDailyActiveUsersFilter,
): Promise<AdminDailyActiveUsersResponse> => {
  const result = await executeGql(adminGetDailyActiveUsers, { filter });
  return processGqlResult<AdminDailyActiveUsersResponse>('adminGetDailyActiveUsers', result);
};
